"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchCoreDataSecurityMonitorByIdSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const get_1 = require("../get.js");
const data_security_1 = require("../../../../api/data-security/index.js");
const update_1 = require("../all/update.js");
const update_2 = require("../application/update.js");
const update_3 = require("../update.js");
exports.patchCoreDataSecurityMonitorByIdSlice = (0, xuder_1.createPatchAsyncSlice)({
    httpSagaOptions: {
        preRequestActionCreators: [
            update_3.updateCoreDataSecurityMonitorsSyncSlice.syncActionCreator,
            update_1.updateCoreDataSecurityMonitorsAllSyncSlice.syncActionCreator
        ],
        successActionCreators: [
            get_1.getCoreDataSecurityMonitorsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitors
        ],
        successCombinationActionCreators: [
            update_2.updateCoreDataSecurityMonitorsByApplicationSyncSlice.syncActionCreator
        ]
    },
    name: name_1.CoreDataSecurityMonitorsByIdName,
    receive: false,
    request: true,
    requestHandler: data_security_1.patchDataSecurityMonitorById
});
//# sourceMappingURL=patch.js.map